/*
Navigation Scripts
*/

jQuery(document).ready(function($){

	/**
	 * Toggle white / blue background and colors in menu when clicking button
	 */
	$('.title-bar.primary').find('*[data-toggle]').click(function(){

		$(this).parents('.title-bar').toggleClass('deployed');
		var responsiveToggleID = '#' + $(this).parents('[data-responsive-toggle]').attr('data-responsive-toggle');
		$(responsiveToggleID).toggleClass('deployed');
	});

	$('.menu.submenu .titre>a').click(function(e){
		e.preventDefault();
		return false;
	});

	$('.toggle-all-menuitems').click(function(){
		var $target = $($(this).attr('data-target'));
		$target.toggleClass('expanded');
	});

	// Disable first level links when parent
	$('.menu .is-dropdown-submenu-parent>a').click(function(e){
		return false;
	});
	// Search icon redirect to search page
   	$("#iconsearch").click(function(){
    	$("#formsearch").submit();
    });
});
	
// Scroll to Newsletter bar if submitted
jQuery(window).load(function(){
	if (jQuery('.mc4wp-alert').length > 0) {
		jQuery('.mc4wp-form').smoothScroll();
	}
});

/* Store the window width */
var windowWidth = jQuery(window).width();

jQuery(window).resize(function(){

	if (jQuery(window).width() != windowWidth) {

		var $titleBar = jQuery('.title-bar.primary');
		var $mobileMenu = jQuery('#' + $titleBar.attr('data-responsive-toggle') );
		if ( jQuery('.title-bar.primary').hasClass('deployed') ){
			$titleBar.removeClass('deployed');
			$mobileMenu.hide().removeClass('deployed');
		}

		windowWidth = jQuery(window).width();

	}
    

});
/**
 * Toggle menu shrink class
 */
var userScrolled = false;

jQuery(window).scroll(function(event) {
	userScrolled = true;
});

setInterval(function(){
	if (userScrolled) {
		hasScrolled();
		userScrolled = false;
	}
}, 150);

function hasScrolled() {
	var triggerDelta = 300;
	var st = jQuery(window).scrollTop();
	var $navbar = jQuery('.sticky');
	if (st >= triggerDelta) {
		$navbar.addClass('slideup');
	} else {
		$navbar.removeClass('slideup');
	}
}